import React from "react";

type Props = React.SVGProps<SVGSVGElement>;

const CashflowIcon: React.FC<Props> = ({ className, ...props }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M11.9297 7.58143C11.815 7.25633 11.6022 6.97484 11.3208 6.77577C11.0393 6.5767 10.703 6.46987 10.3583 6.47H9.06829C8.70026 6.46807 8.34459 6.60268 8.07006 6.84779C7.79553 7.0929 7.62163 7.4311 7.58201 7.79699C7.54238 8.16289 7.63983 8.53048 7.85552 8.82868C8.07121 9.12688 8.38981 9.33452 8.74972 9.41143L10.714 9.84C11.1157 9.92793 11.4706 10.1612 11.7108 10.4949C11.9509 10.8287 12.0592 11.2394 12.0149 11.6482C11.9706 12.0569 11.7768 12.4349 11.4708 12.7095C11.1647 12.9841 10.768 13.1359 10.3569 13.1357H9.24686C8.52115 13.1357 7.904 12.6729 7.67543 12.0257M9.80257 6.47V4.80286M9.80257 14.8029V13.1371M2.854 19.2829V15.7114H6.42543"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1255 8.29141C19.5047 10.3131 19.2019 12.4036 18.2646 14.2346C17.3273 16.0657 15.8086 17.5336 13.9467 18.4082C12.0849 19.2827 9.98538 19.5142 7.9777 19.0665C5.97003 18.6187 4.16786 17.517 2.85404 15.9343M0.874043 11.7086C0.494793 9.68682 0.797581 7.59639 1.73488 5.76535C2.67219 3.93432 4.19094 2.46633 6.05278 1.59181C7.91462 0.717285 10.0141 0.485726 12.0218 0.933477C14.0295 1.38123 15.8317 2.48294 17.1455 4.0657"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1456 0.717102V4.28853H13.5742"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="20" height="20" fill="none" />
      </clipPath>
    </defs>
  </svg>
);

export default CashflowIcon;
